import { render } from "./product_roadmap_item_card.vue?vue&type=template&id=dfe738c6"
import script from "./product_roadmap_item_card.vue?vue&type=script&lang=js"
export * from "./product_roadmap_item_card.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__